export default function About() {
  return (
    <section id="about" className="py-24 bg-zinc-900">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border-4 border-red-600">
              <img
                src="https://static.readdy.ai/image/4290f71dfbaa025f6a9f1c6e0e6bc4ce/c828a939a6dc10d159a8380830c66e60.jpeg"
                alt="Special needs children enjoying train ride"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          
          <div>
            <div className="mb-6">
              <span className="text-red-500 text-sm font-semibold uppercase tracking-wide">(Our Mission)</span>
            </div>
            
            <h2 className="text-5xl md:text-6xl font-bold text-white mb-8 leading-tight">
              Every Child Deserves <span className="text-red-600">Magic</span>
            </h2>
            
            <p className="text-lg text-white/80 mb-8 leading-relaxed">
              At JMS Train Rides, we believe in creating magical experiences for all children. Our custom-built train, 
              featuring a modified tractor and handcrafted train cars, provide safe and accessible rides for everyone, 
              with a focus on special needs children.
            </p>
            
            <p className="text-lg text-white/80 mb-12 leading-relaxed">
              We partner with local charities and organizations to bring joy during holidays like Christmas and Halloween, 
              ensuring that every child, regardless of their abilities, can experience the wonder of a train ride adventure.
            </p>

            <div className="w-full rounded-2xl overflow-hidden border-2 border-red-600">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src="https://www.youtube.com/embed/nThzDqJ7ZMQ"
                  title="JMS Train Rides - Our Mission"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
}